/**
 * Static subway map geometry — the colored route lines and station dots drawn
 * underneath the live train bullets. Derived once from GTFS static (shapes.txt
 * and stops.txt) and served to the client via a cached HTTP endpoint, since it
 * never changes between GTFS refreshes. Plain GeoJSON so deck.gl can consume it
 * directly (PathLayer for lines, ScatterplotLayer for stations).
 *
 * All types here are aliases of the generic MapGeometry family from
 * mapGeometry.ts so the LIRR (and any future) map can reuse the same shape.
 */
/**
 * Cache-bust version for the static geometry payload. The client appends it to
 * the fetch URL (`/api/subway-geometry?v=N`) so any change busts the long (12h)
 * HTTP cache: returning clients request a never-before-cached URL and get the
 * fresh payload instead of a stale one. BUMP THIS on any change to the emitted
 * coordinates or feature shape — schema OR geometry tuning (offset spacing etc).
 * (v1 = routeId lines; v2 = color ribbons; v3 = tighter offset spacing; v4 =
 * corner rounding + tapered ribbon offsets; v6 = branch fragments survive
 * same-color dedup; v7 = branch fragments join their trunk at forks; v8 = fragments overlap
 * the trunk corridor so offset ribbons merge; v9 = fragments trimmed onto the
 * drawn trunk so forks render as a clean Y; v10 = tangential landing instead
 * of a perpendicular stub; v12 = route-aligned transfer markers with distinct
 * marker and selection IDs.)
 */
export const SUBWAY_GEOMETRY_VERSION = 12;
